import { saveAs } from "file-saver";
import moment from "moment";
import React, { Component } from "react";
import "react-datetime/css/react-datetime.css";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class DisplayPackingList extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;

        var pl = Comm.PackingList({
            session: sid,
            id: this.props.match.params.id,
            lang: Translation.CurrentLanguage().toLowerCase(),
        });
        var html = pl.html;
        html = html.replace(/fixed/gi, "relative");
        html = html + "<nocache id='" + moment().format() + "'/>";
        this.state = {
            DisplayedPackingList: this.props.match.params.id,
            PackingListHtml: html,
            Landscape: pl.landscape,
        };
        this.PrintElem = this.PrintElem.bind(this);
        this.Export = this.Export.bind(this);
    }

    Export(content) {
        var html =
            "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8' /></head><body>" +
            content +
            "</body></html>";
        var file = new Blob([html]);
        saveAs(file, "export.xls");
    }

    RotateColumns(document) {
        var headings = document.getElementsByClassName("vert");
        for (var iter = 0; iter < headings.length; iter++) {
            var h = headings[iter];
            var label = h.innerText.trim();
            h.innerHTML = "";
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = h.style.font;
            context.textAlign = "right";
            context.save();
            var metrics = context.measureText(label);
            canvas.height = parseInt(metrics.width, 10);
            canvas.width = context.measureText("M").width; //най-точно приближение
            context.restore();
            context.font = h.style.font;
            //context.fillStyle = "#ff0000"; // red
            context.textAlign = "right";

            // hold top-right hand corner when rotating
            context.translate(canvas.width - 1, 0);
            //context.translate(0, 0);

            context.rotate((3 * Math.PI) / 2);

            context.fillText(label, 0, 0);
            h.appendChild(canvas);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.RotateColumns(document);
    }

    componentDidMount() {
        this.RotateColumns(document);
    }

    PrintElem() {
        var mywindow = window.open("", "PRINT", "height=400,width=600");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        if (this.state.Landscape)
            mywindow.document.write("<style>@media print {@page {size: landscape}}</style>");
        mywindow.document.write("</head><body >");
        //mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(this.state.PackingListHtml);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        this.RotateColumns(mywindow.document);
        mywindow.print();
        mywindow.close();

        return true;
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        return Context.HasRight("rsalesreport") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("sales")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div
                            className="col-md-12"
                            id="dPackingList"
                            dangerouslySetInnerHTML={{ __html: this.state.PackingListHtml }}
                        ></div>
                        <div className="col-md-12">
                            <button className="btn btn-primary" onClick={this.PrintElem}>
                                <i className="fa fa-print"></i>
                                <p>{Translation.Trans("print")}</p>
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={() => this.Export(this.state.PackingListHtml)}
                            >
                                <i className="fas fa-table"></i>
                                <p>{Translation.Trans("export")}</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default DisplayPackingList;



// WEBPACK FOOTER //
// ./src/pages/displaypackinglist.js